const headRowsManagementService = {
  date: 'Fecha',
  equipmentEquipmentParamName: 'Equipo',
  inspection: 'Tipo de Servicio',
  questions: 'Checklist',
  placeName: 'Lugar',
  user: 'Realizado por',
  description: 'Observación',
  score: 'Puntuación',
};

export default headRowsManagementService;
